/* eslint-disable object-property-newline */

function processRelationship(molten, relationship, options) {
  const {
    attribute,
    blueprint
  } = relationship;
  if (attribute == null) {
    const type = blueprint.type;
    const icons = blueprint.getIcon('mapbox') || blueprint.metadata?.icons?.mapbox;
    if (icons) {
      Object.keys(icons).forEach(name => {
        const icon = icons[name];
        const {
          src,
          width,
          height,
          mapsTo
        } = icon;
        const symName = `${type}-${name}`;
        if (mapsTo) {
          molten.addPlugin('MapSymbol', {
            name: symName,
            mapsTo
          });
        } else if (src != null) {
          molten.addPlugin('MapSymbol', {
            name: symName,
            src,
            width,
            height
          });
        }
      });
    }
  }
}
export default {
  type: 'molten.BlueprintMapBoxSymbolCreator',
  processRelationship
};